import {Component, DestroyRef, inject, Input} from '@angular/core';
import {BokkzIbDataService, IncomeTaxEntity} from '@snelstart-ventures/fiscaal/domain-logic';
import {SharedUiAlertModule} from '@snelstart/ui-alert';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {filter, Observable, shareReplay, take} from 'rxjs';
import {SharedUiTooltipModule} from '@snelstart/ui-tooltip';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3-owr',
  templateUrl: './box3-owr.component.html',
  styleUrls: ['./box3-owr.component.scss'],
  imports: [
    SharedUiAlertModule,
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    SharedUiTooltipModule,
    AsyncPipe
  ]
})
export class Box3OwrComponent {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataService = inject(BokkzIbDataService);
  public isDefAangifte = false;

  public formGroup = new FormGroup({
    berekenWerkelijkRendement: new FormControl<boolean | null>(null),
  });

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: false, label: 'Nee'},
    {value: true, label: 'Ja'},
  ];

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> =
    this.dataService.incomeTaxEntity$.pipe(
      filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  ngOnInit(): void {
    this.incomeTaxEntity$.pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((data) => {
      this.isDefAangifte = data.taxType === 'DA';
      if (data.taxType === 'VA') {
        this.formGroup.patchValue({berekenWerkelijkRendement: false}, {emitEvent: false});
      }
      else {
        this.formGroup.patchValue({berekenWerkelijkRendement: data?.aangifte?.box3?.berekenWerkelijkRendement ?? false}, {emitEvent: false});
      }
    });
  }

  ngOnDestroy(): void {
    // rely on saveFrom in component
  }

  saveForm(): void {
    this.formGroup.updateValueAndValidity({emitEvent: false});

    this.dataService.patchIncomeTaxEntity(currentEntity => {
      if (!currentEntity.aangifte) {
        return currentEntity;
      }

      return {
        ...currentEntity,
        aangifte: {
          ...currentEntity.aangifte,
          box3: {
            ...currentEntity.aangifte.box3,
            berekenWerkelijkRendement: this.formGroup.getRawValue().berekenWerkelijkRendement ?? false,
          }
        },
      } as IncomeTaxEntity;
    });
  }
}
